<script lang="ts">
  import { onMount } from 'svelte';
  import { api } from '../lib/api';
  import { sessionIn } from '../lib/stores/session';
  import { ApiErr } from '../lib/types';

  /** Backend error code (internal/api/handlers_auth.go) → user-facing line. */
  const MESSAGES: Record<string, string> = {
    bad_credentials: 'Sai mật khẩu.',
    rate_limited: 'Thử lại sau một phút.',
    not_provisioned: 'Máy chủ chưa đặt mật khẩu — chạy `watchfeed passwd` trên server.',
    network: 'Không kết nối được máy chủ.',
  };

  let password = $state('');
  let busy = $state(false);
  let error = $state('');
  let field: HTMLInputElement;

  onMount(() => field?.focus());

  async function submit(event: SubmitEvent): Promise<void> {
    event.preventDefault();
    if (busy || password === '') return;
    busy = true;
    error = '';
    try {
      await api.login(password);
      sessionIn(); // App.svelte replaces this screen with the dashboard; keep busy=true through the unmount
    } catch (err) {
      const code = err instanceof ApiErr ? err.code : '';
      error = MESSAGES[code] ?? (err instanceof ApiErr ? err.message : 'Đăng nhập thất bại.');
      password = '';
      busy = false;
      field?.focus();
    }
  }
</script>

<main class="app login">
  <form class="logincard" onsubmit={submit}>
    <span class="wordmark">Watch<b>feed</b></span>
    <label>
      Mật khẩu
      <input
        bind:this={field}
        bind:value={password}
        type="password"
        autocomplete="current-password"
        disabled={busy}
      />
    </label>
    {#if error}
      <p class="loginerr" role="alert">{error}</p>
    {/if}
    <button type="submit" disabled={busy || password === ''}>
      {busy ? 'Đang vào…' : 'Vào'}
    </button>
  </form>
</main>
